import {
  ADD_ITEM_TO_TEMP_CART,
  REMOVE_ITEM_TO_TEMP_CART,
  CLEAR_ITEMS_IN_TEMP_CART
} from "../actions";

export default function tempCart(state = {}, action) {
  switch (action.type) {
    case ADD_ITEM_TO_TEMP_CART: {
      let key = Object.keys(action.payload)[0];
      return { ...state, [key]: { ...action.payload[key] } };
    }
    case REMOVE_ITEM_TO_TEMP_CART: {
      let foodId = action.payload;
      let newState = { ...state };
      delete newState[foodId];
      return newState;
    }
    case CLEAR_ITEMS_IN_TEMP_CART:
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/tempCart.js